import { Col, Row, Input } from "antd";
import React, { useEffect } from "react";
import TmsSelect from "../../../../../../components/tms-customs/tms-select";
import TmsDatepickerRange from "../../../../../../components/tms-customs/tms-datepicker-range";
import TmsAddress from "../../../../../../components/tms-customs/tms-address";
import {
  additionalShopArrearStates,
  arrearShopStates,
  yesOrNotData,
} from "../../../../../../constants/states-data.data";
import TmsImageUpload from "../../../../../../components/tms-customs/tms-image-upload";
import TmsCancelSubmitButtons from "../../../../../../components/tms-customs/tms-cancel-submit-buttons";
import { arrowRight } from "../../../../../../assets/images/tms-image-list";
import TmsCheckbox from "../../../../../../components/tms-customs/tms-checkbox";
import {
  BuildingBlockNoSelect,
  BuildingInstitutionSelect,
  BuildingLeaseSelect,
  BuildingSelect,
} from "../../../../../../components/tms-customs/rents-and-leases";
import moment from "moment";
import useBuildingsStore from "../../../../../../zustand/buildings-and-shops.store";

const TmsArearsCreation = ({ router, setVisible }) => {
  const {
    selectedInstitution,
    setArrearPeriodInMonths,
    arrearPeriodInMonths,
    setRemarks,
    setSubmitLoading,
    submitLoading,
    legalAction,
    setLegalAction,
    setLegalReason,
    legalReason,
    caseNo,
    setCaseNo,
    selectedBuildingLease,
    casePDF,
    selectedBuilding,
    selectedBlock,
    fetchBlocks,
    setCasePDF,
    fetchInstitutionList,
    clearStates,
    fetchCreatedBuildingsList,
    fetchLandLeases,
    setArrearAmount,
    arrearAmount,
    interestAmount,
    setInterestAmount,
    setStatus,
    status,
    handleArrearCreation,
    remarks,
  } = useBuildingsStore();

  useEffect(() => {
    fetchInstitutionList(1, 200, "ASC", "createdAt", router);
    return () => {
      clearStates(arrearShopStates, additionalShopArrearStates);
    };
  }, []);

  useEffect(() => {
    if (selectedInstitution !== "" && selectedInstitution)
      fetchCreatedBuildingsList(1, 200, "ASC", "createdAt", router);
  }, [selectedInstitution]);

  useEffect(() => {
    if (
      selectedInstitution !== "" &&
      selectedInstitution &&
      selectedBuilding?.id
    ) {
      fetchBlocks(1, 200, "ASC", "createdAt", router);
    }
  }, [selectedInstitution, selectedBuilding]);

  useEffect(() => {
    if (
      selectedBuilding !== "" &&
      selectedBuilding &&
      selectedBlock !== "" &&
      selectedBlock
    )
      fetchLandLeases(1, 200, "ASC", "createdAt", router);
  }, [selectedBlock, selectedBuilding]);

  return (
    <>
      <Row justify="flex-start" gutter={[20, 20]}>
        <BuildingInstitutionSelect span={6} />
        <BuildingSelect span={6} />
        <BuildingBlockNoSelect span={6} />
        <BuildingLeaseSelect span={6} />
      </Row>
      <br />
      <Row
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333333",
          width: "100%",
        }}
      >
        Land Details
      </Row>{" "}
      <Row justify="flex-start" gutter={[20, 20]}>
        <Col span={6}>
          <TmsDatepickerRange
            label="Select Lease Period"
            to={moment(selectedBuildingLease?.leasePeriodEndDate)}
            from={moment(selectedBuildingLease?.leasePeriodStartDate)}
            // setFrom={setLeasePeriodStartDate}
            // setTo={setLeasePeriodEndDate}
            disabled={true}
          />{" "}
        </Col>
        <Col span={6}>
          <Row className={"t-left"}>Arrear Amount</Row>
          <Input
            maxLength={220}
            type="number"
            min="0"
            placeholder="Enter Arrear Amount"
            value={arrearAmount}
            onChange={(e) => {
              setArrearAmount(e.target.value);
            }}
            onWheel={(event) => event.currentTarget.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Col>
        <Col span={6}>
          <Row className={"t-left"}>Interest Amount</Row>
          <Input
            maxLength={220}
            type="number"
            min="0"
            placeholder="Enter Interest Amount"
            value={interestAmount}
            onChange={(e) => {
              setInterestAmount(e.target.value);
            }}
            onWheel={(event) => event.currentTarget.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Col>
        <Col span={6}>
          <Row className={"t-left"}>Arrear Period In Months</Row>
          <Input
            maxLength={220}
            type="number"
            min="0"
            placeholder="Enter Arrear period in months"
            value={arrearPeriodInMonths}
            onChange={(e) => {
              e.target.value < 360 && setArrearPeriodInMonths(e.target.value);
            }}
            onWheel={(event) => event.currentTarget.blur()}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Col>
      </Row>{" "}
      <br /> <br />
      <Row
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333333",
          width: "100%",
        }}
      >
        Lessee Details
      </Row>{" "}
      <br />
      <Row justify="flex-start" gutter={[20, 20]}>
        <Col span={6}>
          <Row className={"t-left"}>Lessee Name</Row>
          <Input
            maxLength={220}
            type="text"
            placeholder="Enter Lessee Name"
            value={selectedBuildingLease?.lesseName}
            disabled={true}
          />
        </Col>
        <Col span={6}>
          <Row className={"t-left"}>Mobile Number</Row>
          <Input
            type="number"
            min="0"
            prefix="+91"
            onWheel={(event) => event.currentTarget.blur()}
            maxLength={10}
            value={selectedBuildingLease?.mobileNumber?.replace("+91", "")}
            disabled={true}
            onKeyDown={(e) =>
              ["e", "E", "+", "-", "."].includes(e.key) && e.preventDefault()
            }
          />
        </Col>

        <TmsAddress
          span={6}
          village={selectedBuildingLease?.village}
          mandal={selectedBuildingLease?.mandal}
          district={selectedBuildingLease?.district}
          country={selectedBuildingLease?.country}
          state={selectedBuildingLease?.state}
          zip={selectedBuildingLease?.pincode}
          type="general"
          disabled={true}
        />
      </Row>
      <br /> <br />
      <Row
        style={{
          fontSize: "24px",
          fontWeight: "bold",
          color: "#333333",
          width: "100%",
        }}
      >
        Legal Case Details
      </Row>
      <br />
      <Row justify="flex-start" gutter={[20, 20]}>
        <TmsSelect
          selectClass="w-100 "
          classname="mr-0 "
          type="col"
          value={legalAction}
          setValue={setLegalAction}
          label="Legal Action"
          data={yesOrNotData}
          span={12}
          optional={true}
        />
        {legalAction ? (
          <>
            <Col span={12}>
              <Row className={"t-left"}>If yes Case Number</Row>
              <Input
                maxLength={220}
                type="text"
                onWheel={(event) => event.currentTarget.blur()}
                onKeyDown={(e) =>
                  ["+", "-", "."].includes(e.key) && e.preventDefault()
                }
                placeholder="Enter Case No"
                value={caseNo}
                onChange={(e) => setCaseNo(e.target.value)}
              />
            </Col>
            <Col span={12}>
              <Row className={"t-left"}>Upload File(PDF)</Row>
              <TmsImageUpload
                fileList={casePDF}
                setFileList={setCasePDF}
                router={router}
                type="private"
                accept={true}
                className="w-100"
              />
            </Col>
          </>
        ) : (
          <Col span={12}>
            {" "}
            <Row className={"t-left"}>Reason</Row>
            <Input
              maxLength={220}
              type="text"
              placeholder="Enter Remarks"
              value={legalReason}
              onChange={(e) => setLegalReason(e.target.value)}
            />
          </Col>
        )}
        <Col span={12}>
          {" "}
          <Row className={"t-left"}>Remarks</Row>
          <Input
            maxLength={220}
            type="text"
            placeholder="Enter Remarks"
            value={remarks}
            onChange={(e) => setRemarks(e.target.value)}
          />
        </Col>
      </Row>{" "}
      <br />
      <TmsCheckbox
        label={"Arrear Status"}
        value={status}
        setValue={setStatus}
      />
      <TmsCancelSubmitButtons
        icon={arrowRight}
        cancelOnlick={() => {
          clearStates(arrearShopStates, additionalShopArrearStates);
          setSubmitLoading(false);
          setVisible(false);
        }}
        submitOnclick={() => !submitLoading && handleArrearCreation(router)}
        loading={submitLoading}
      />
    </>
  );
};

export default TmsArearsCreation;
